"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAQRecommender = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSvg = require("react-svg");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Message = require("../Message");
var _Button = require("../Button");
var _arrow_down_orange = _interopRequireDefault(require("../../assets/images/arrow_down_orange.svg"));
var _LocaleProvider = require("../LocaleProvider");
var _excluded = ["_id", "className"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var pageSize = 3;
var FAQRecommender = function FAQRecommender(props) {
  var _messageProps$buttonG, _messageProps$buttonG2;
  var _id = props._id,
    className = props.className,
    messageProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var defaultShowViewMore = props.showViewMore && ((_messageProps$buttonG = (_messageProps$buttonG2 = messageProps.buttonGroup) === null || _messageProps$buttonG2 === void 0 ? void 0 : _messageProps$buttonG2.buttons.length) !== null && _messageProps$buttonG !== void 0 ? _messageProps$buttonG : 0) > pageSize;
  var _useState = (0, _react.useState)(defaultShowViewMore),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showViewMore = _useState2[0],
    setShowViewMore = _useState2[1];
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('faq-recommender'), className)
  }, /*#__PURE__*/_react.default.createElement(_Message.Message, (0, _extends2.default)({}, messageProps, {
    buttonGroup: _objectSpread(_objectSpread({}, messageProps.buttonGroup), {}, {
      buttons: showViewMore ? messageProps.buttonGroup.buttons.slice(0, 3) : messageProps.buttonGroup.buttons
    })
  })), showViewMore && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: function onClick() {
      return setShowViewMore(false);
    },
    className: (0, _getPrefixCls.getPrefixCls)('faq-recommender-btn')
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, trans('key_answer_view_more_btn')), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _arrow_down_orange.default
  }))));
};
exports.FAQRecommender = FAQRecommender;